import { FC, HTMLProps, useLayoutEffect, useRef, useState } from "react";
import styles from "./PartnerCard.module.scss";
import classNames from "classnames";
import Image, { StaticImageData } from "next/image";
import Arrow from "./arrow.svg";
import { screenSizes } from "../../../utils/constants";
import { gsap } from "gsap";

gsap.config({ nullTargetWarn: false });

export type Props = {
  logo: StaticImageData;
  logoSmall: StaticImageData;
  title: string;
  desc: string;
  addclasses?: string[];
} & HTMLProps<HTMLDivElement>;

let animation: gsap.core.Timeline | null = null;

const PartnerCard: FC<Props> = (props) => {
  const { logo, logoSmall, title, desc, addclasses } = props;
  const className = classNames(
    [styles["container"], addclasses && [...addclasses]],
    {}
  );
  const [opened, setOpened] = useState(false);
  const root = useRef(null);
  const animRef = useRef<any>(null);
  const mm = gsap.matchMedia();

  const handleClick = () => {
    setOpened((prev) => !prev);
  };

  useLayoutEffect(() => {
    mm.add(
      screenSizes,
      () => {
        const tl = gsap.timeline();
        if (opened) {
          tl.to(root.current, { height: "auto" });
          tl.to(`.${styles["arrow"]}`, { rotateX: 180 }, "<");
          animRef.current = tl;
        } else {
          animRef.current !== null && animRef.current.reverse();
          animRef.current = null;
        }
      },
      root
    );
  }, [opened]);

  return (
    <div ref={root} className={className} onClick={handleClick}>
      <picture className={styles["img-container"]}>
        <source srcSet={logoSmall?.src} media="(max-width: 600px)" />
        <Image src={logo} alt="" />
      </picture>
      <Arrow className={styles["arrow"]} />
      <div className={styles["text"]}>
        <h3>{title}</h3>
        <p>{desc}</p>
      </div>
    </div>
  );
};

export default PartnerCard;
